import request from '@/utils/request'

/**
 * 获取文件可访问地址
 * @param data
 * @returns {*}
 */
export function getFileRealPath(data) {
  return request({
    url: '/api/an/worker/getFileUrlById',
    method: 'get',
    params: data
  })
}

export function uploadWithoutOssToken(data) {
  return request({
    url: '/api/an/getUploadToken',
    method: 'get',
    params: data
  })
}

export function getFileUrl(data) {
  return request({
    url: '/api/an/getFileUrlById',
    method: 'get',
    params: data
  })
}

/**
 * 获取城市
 * @returns {*}
 */
export function getNoAuthCityList() {
  return request({
    url: '/api/an/getCityList',
    method: 'get'
  })
}

export function createPdf(data) {
  return request({
    url: '/api/an/worker/createPdfFile',
    method: 'post',
    data: data
  })
}

/**
 * 获取公司列表
 * @param data
 * @returns {*}
 */
export function getCompanyList(data) {
  return request({
    url: '/api/an/worker/GetCompanyList',
    method: 'get',
    data: data
  })
}


/**
 * 获取图片Oss地址
 * @param data
 * @returns {*}
 */
export function getFileOssUrl(data) {
  return request({
    url: '/api/an/worker/getFileOssUrl',
    method: 'get',
    params: data
  })
}

export function getPdfFileName(data) {
  return request({
    url: '/api/an/worker/getConstructionPdfFileName',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/util.js